import { GroupeActivite } from './GroupeActivite';
import { MobiDocument } from './MobiDocument';

export class PointageDetailInoeDocument extends MobiDocument {

    private _id: string;
    private _rev: string;
    private id: number;
    private pointage_id: number;
    private tempsdebut: string;
    private tempsfin: number;
    private palette_id: number;
    private elementfrise_id: number;
    private tariftempssupplactivite_id: number;
    private groupeactivite_id: number;
    private ordrelisteattente: number;
    private ordrelisteattentegroupe: number;


    public constructor(pointagedetailinoe: any) {
        super()
        this._id = pointagedetailinoe._id;
        this._rev = pointagedetailinoe._rev;
        this.id = pointagedetailinoe.id;
        this.pointage_id = pointagedetailinoe.pointage_id;
        this.tempsdebut = pointagedetailinoe.tempsdebut;
        this.tempsfin = pointagedetailinoe.tempsfin;
        this.palette_id = pointagedetailinoe.palette_id;
        this.elementfrise_id = pointagedetailinoe.elementfrise_id;
        this.tariftempssupplactivite_id = pointagedetailinoe.tariftempssupplactivite_id;
        this.ordrelisteattente = pointagedetailinoe.ordrelisteattente;
        this.ordrelisteattentegroupe = pointagedetailinoe.ordrelisteattentegroupe;
        this.groupeactivite_id = pointagedetailinoe.groupeactivite_id;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getPointage_id(): number {
        return this.pointage_id;
    }

    public setPointage_id(pointage_id: number): void {
        this.pointage_id = pointage_id;
    }

    public getTempsdebut(): string {
        return this.tempsdebut;
    }

    public setTempsdebut(tempsdebut: string): void {
        this.tempsdebut = tempsdebut;
    }

    public getTempsfin(): number {
        return this.tempsfin;
    }

    public setTempsfin(tempsfin: number): void {
        this.tempsfin = tempsfin;
    }

    public getPalette_id(): number {
        return this.palette_id;
    }

    public setPalette_id(palette_id: number): void {
        this.palette_id = palette_id;
    }
    public getElementfrise_id(): number {
        return this.elementfrise_id;
    }

    public setElementfrise_id(elementfrise_id: number): void {
        this.elementfrise_id = elementfrise_id;
    }

    public getTariftempssupplactivite_id(): number {
        return this.tariftempssupplactivite_id;
    }

    public setTariftempssupplactivite_id(tariftempssupplactivite_id: number): void {
        this.tariftempssupplactivite_id = tariftempssupplactivite_id;
    }
    public getOrdrelisteattente(): number {
        return this.ordrelisteattente;
    }

    public setOrdrelisteattente(ordrelisteattente: number): void {
        this.ordrelisteattente = ordrelisteattente;
    }

    public getOrdrelisteattentegroupe(): number {
        return this.ordrelisteattentegroupe;
    }

    public setOrdrelisteattentegroupe(ordrelisteattentegroupe: number): void {
        this.ordrelisteattentegroupe = ordrelisteattentegroupe;
    }

    public getGroupeactivite_id(): number {
        return this.groupeactivite_id;
    }

    public setGroupeactivite_id(groupeactivite_id: number): void {
        this.groupeactivite_id = groupeactivite_id;
    }

    public getGroupeActivite(): GroupeActivite{
        return this.memdb.findOne({
            doctype: "GroupeActiviteDocument",
            fkey: "id",
            fvalue: this.groupeactivite_id

        }) as GroupeActivite;
    }

}